import React from "react";

import { useFullScreenContext } from "@/contexts/full-screen-context";
import { cn } from "@/utils/cn";

import { Layout } from "../components/ui";

interface AiPageProps {
  children: React.ReactNode;
}

export default function AiPage({ children }: AiPageProps) {
  const { isFullScreen } = useFullScreenContext();

  return (
    <Layout.Main
      className={cn("h-screen pb-0! md:col-span-12! lg:overflow-hidden", {
        "lg:col-span-9!": !isFullScreen,
        "lg:col-span-12!": isFullScreen,
      })}
    >
      {children}
    </Layout.Main>
  );
}
